import React, { useState } from 'react';
import AdminSidebar from './components/AdminSidebar';
import Header from '../teacher_screen/components/Header';
import {
    Bell,
    Plus,
    Filter,
    MoreHorizontal,
    Megaphone,
    Calendar,
    Users,
    ChevronRight,
    Search,
    Trash2,
    Send
} from 'lucide-react';

export default function Notices() {
    const notices = [
        { id: 1, title: 'Annual Sports Meet 2026', date: 'Mar 15, 2026', audience: 'Whole School', priority: 'High', status: 'Published' },
        { id: 2, title: 'Term 2 Result Publication', date: 'Mar 25, 2026', audience: 'Parents', priority: 'Critical', status: 'Draft' },
        { id: 3, title: 'New Science Lab Inauguration', date: 'Apr 02, 2026', audience: 'Staff', priority: 'Medium', status: 'Scheduled' },
        { id: 4, title: 'Maintenance Notice - Block B', date: 'Mar 10, 2026', audience: 'Whole School', priority: 'Low', status: 'Published' },
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <AdminSidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Bulletin Board"
                    subtitle="Broadcast important updates, events and official announcements"
                >
                    <button className="flex items-center gap-2 px-5 py-2.5 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        Post Notice
                    </button>
                </Header>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mb-10 overflow-hidden">
                    <div className="lg:col-span-1 space-y-6">
                        <div className="bg-[#111827] rounded-[32px] p-8 text-white">
                            <Megaphone size={32} className="text-blue-500 mb-6" />
                            <h3 className="text-[20px] font-black mb-2 leading-tight uppercase tracking-tight">Broadcast Center</h3>
                            <p className="text-gray-400 text-[13px] font-bold leading-relaxed mb-8">Reach thousands of students and parents instantly with one click.</p>
                            <div className="flex flex-col gap-3">
                                <div className="flex items-center justify-between p-3 bg-white/5 rounded-xl border border-white/10">
                                    <span className="text-[12px] font-bold uppercase">SMS Reach</span>
                                    <span className="text-blue-400 font-black">98%</span>
                                </div>
                                <div className="flex items-center justify-between p-3 bg-white/5 rounded-xl border border-white/10">
                                    <span className="text-[12px] font-bold uppercase">App Alerts</span>
                                    <span className="text-blue-400 font-black">4.2k</span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white rounded-[32px] p-8 border border-gray-100 shadow-sm">
                            <h4 className="text-[16px] font-black text-[#111827] mb-6 uppercase tracking-tight">Active Campaigns</h4>
                            <div className="space-y-4">
                                <div className="flex items-center gap-4">
                                    <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
                                    <span className="text-[13px] font-black text-gray-700">Admission Open 2026</span>
                                </div>
                                <div className="flex items-center gap-4">
                                    <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                                    <span className="text-[13px] font-black text-gray-700">Scholarship Drive</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-3 bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col">
                        <div className="p-8 border-b border-gray-50 flex items-center justify-between bg-[#F8FAFC]/50">
                            <h3 className="text-[20px] font-black text-[#111827]">Announcement Feed</h3>
                            <div className="flex items-center gap-2">
                                <div className="relative group">
                                    <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                    <input
                                        type="text"
                                        placeholder="Search by title..."
                                        className="pl-9 pr-4 py-2 bg-white border border-gray-100 rounded-xl text-[13px] font-bold text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all"
                                    />
                                </div>
                                <button className="p-2 text-gray-400 hover:text-gray-900 border border-gray-100 rounded-lg bg-white"><Filter size={18} /></button>
                            </div>
                        </div>

                        <div className="flex flex-col">
                            {notices.map((n) => (
                                <div key={n.id} className="p-8 border-b border-gray-50 last:border-0 hover:bg-slate-50 transition-all group flex items-start justify-between gap-6 cursor-pointer">
                                    <div className="flex gap-6 items-start">
                                        <div className={`w-14 h-14 rounded-2xl flex items-center justify-center font-black shadow-lg transition-all group-hover:scale-110 shrink-0 ${n.priority === 'Critical' ? 'bg-rose-500 shadow-rose-100 text-white' :
                                                n.priority === 'High' ? 'bg-orange-500 shadow-orange-100 text-white' :
                                                    'bg-blue-500 shadow-blue-100 text-white'
                                            }`}>
                                            <Bell size={24} />
                                        </div>
                                        <div>
                                            <div className="flex items-center gap-3 mb-1">
                                                <h4 className="text-[18px] font-black text-[#111827] group-hover:text-blue-600 transition-colors uppercase tracking-tight leading-none">{n.title}</h4>
                                                <span className={`px-2 py-0.5 rounded text-[10px] font-black uppercase tracking-tighter ${n.status === 'Published' ? 'bg-emerald-50 text-emerald-500' : 'bg-slate-100 text-slate-400'
                                                    }`}>{n.status}</span>
                                            </div>
                                            <div className="flex items-center gap-4 text-[13px] font-bold text-gray-400 uppercase tracking-tighter">
                                                <span className="flex items-center gap-1.5"><Calendar size={14} className="text-blue-500" /> {n.date}</span>
                                                <span className="flex items-center gap-1.5"><Users size={14} className="text-blue-500" /> For {n.audience}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-2 self-center">
                                        <button className="p-2 text-gray-300 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all"><Send size={20} /></button>
                                        <button className="p-2 text-gray-300 hover:text-rose-500 hover:bg-rose-50 rounded-xl transition-all"><Trash2 size={20} /></button>
                                        <ChevronRight size={20} className="text-gray-200 group-hover:text-gray-900 transition-all ml-2" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
